<template>
    <div :style="`background-image: url(${logos.coblue});`" class="logo" />
</template>

<script>
import LogoCoBlue from '@/assets/logos/coblue_256x57.svg'

export default {
    name: 'LogoCoBlue',
    data() {
        return {
            logos: {
                coblue: LogoCoBlue,
            },
        }
    },
}
</script>

<style lang="scss" scoped>
.logo {
    width: 256px;
    height: 57px;
    display: inline-block;
    background-repeat: no-repeat;
}
</style>
